import { Request } from 'api';
import { AxiosResponse } from 'axios';
import { SharedUser } from 'utils';

type ReturnType = Promise<AxiosResponse<Array<SharedUser>>>;

const addUserToMovement = (
    id: string,
    users: Array<string>,
    role: string,
    message?: string,
): ReturnType => {
    return Request.post(`/workouts/movements/${id}/users`, {
        users,
        role,
        message,
    });
};

export default addUserToMovement;
